import type { ComponentProps, CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomArrowUpRightLinkProps = ComponentProps<"svg">

function IconCustomArrowUpRightLink(props: IconCustomArrowUpRightLinkProps) {
  const {
    className,
    style,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    fill: _ignoredFill,
    width: _ignoredWidth,
    height: _ignoredHeight,
    ...svgProps
  } = props

  const sizeStyle: CSSProperties = {
    width: style?.width ?? 14,
    height: style?.height ?? 14,
    flexShrink: 0,
    ...style,
  }

  return (
    <svg
      className={cn("block", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={sizeStyle}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <path d="M7 7h10v10" fill="none" />
      <path d="M7 17 17 7" fill="none" />
    </svg>
  )
}

export default IconCustomArrowUpRightLink
